import store from '@geek/yum-freight-framework/src/store'
import { checkFunction } from '@geek/yum-freight-framework/src/directives/functionIndex'

export const GO_FREIGHT_FUNCTION_KEY = 'giga_go_freight'
const FUNCTION_KEY_CACHE = 'functionKeyList'

const ENGLISH_NAME_PROPS = new Set(['surchargeEnName', 'customerNameEn', 'nameEn'])
const ENGLISH_NAME_FIELDS = new Set(['customerNameEn'])

function getCachedFunctionKeys() {
  try {
    const cached = sessionStorage.getItem(FUNCTION_KEY_CACHE)
    if (!cached) return []
    const keys = JSON.parse(cached)
    return Array.isArray(keys) ? keys : []
  } catch (e) {
    return []
  }
}

export function isGoFreightUser() {
  try {
    if (sessionStorage.getItem(GO_FREIGHT_FUNCTION_KEY) === '1') {
      return true
    }
  } catch (e) {
    // ignore
  }
  const cachedKeys = getCachedFunctionKeys()
  if (cachedKeys.includes(GO_FREIGHT_FUNCTION_KEY)) {
    return true
  }
  const storeKeys = store?.getters?.functionKey
  if (Array.isArray(storeKeys) && storeKeys.includes(GO_FREIGHT_FUNCTION_KEY)) {
    return true
  }
  return checkFunction(GO_FREIGHT_FUNCTION_KEY)
}

export function isEnglishNameField(item) {
  if (!item) return false
  if (item.prop && ENGLISH_NAME_PROPS.has(item.prop)) return true
  if (item.field && ENGLISH_NAME_FIELDS.has(item.field)) return true
  if (item.props === 'customerNameEn') return true
  return false
}

export function hasEnglishNameField(list) {
  return Array.isArray(list) && list.some(isEnglishNameField)
}

export function filterEnglishNameList(list) {
  if (!isGoFreightUser() || !Array.isArray(list)) return list
  return list.filter(item => !isEnglishNameField(item))
}

export function filterEnglishNameTableSource(tableSource) {
  if (!tableSource || !isGoFreightUser()) return tableSource
  if (Array.isArray(tableSource.allColumn)) {
    tableSource.allColumn = filterEnglishNameList(tableSource.allColumn)
  }
  if (Array.isArray(tableSource.allFilterField)) {
    tableSource.allFilterField = filterEnglishNameList(tableSource.allFilterField)
  }
  return tableSource
}

export function syncGoFreightTableColumns(vm) {
  if (!vm || !isGoFreightUser()) return
  if (vm.$options.name === 'YunTableList' && vm.tableSource) {
    filterEnglishNameTableSource(vm.tableSource)
    if (hasEnglishNameField(vm.tableColumn)) {
      vm.tableColumn = filterEnglishNameList(vm.tableColumn)
      vm.$nextTick(() => {
        vm.$refs?.table?.doLayout()
      })
    }
    const tableNav = vm.$refs?.tableNav
    if (tableNav?.columnData?.selectColumn && hasEnglishNameField(tableNav.columnData.selectColumn)) {
      tableNav.columnData.selectColumn = filterEnglishNameList(tableNav.columnData.selectColumn)
    }
  }
  vm.$children?.forEach(syncGoFreightTableColumns)
}
